import axios from 'axios';
import { BASE_URL } from 'constants/env';

export const WH_INSTANCE_ACTION = async (e) => {
  const { id, ...remaining } = e;
  const res = await axios.post(BASE_URL + `/wh/instance/${id}/actions`, remaining);
  return res.data;
};

export const UPDATE_SERVER_SIZE = async (e) => {
  const { id, ...remaining } = e;
  const res = await axios.post(BASE_URL + `/wh/instance/${id}/sizechange`, remaining);
  return res.data;
};

export const MANAGE_WH = async (e) => {
  const res = await axios.get(BASE_URL + `/wh`, { params: e.queryKey[1] });
  return res.data;
};
